export default {
    zh: {
        rules: "规则",
        get: "领取",
        chips: "碎片",
        moreChips: "邀请好友获得更多碎片",
        more: "更多",
        unlock: "解锁一次",
        task: "活动任务",
        task1: "登录三天",
        task2: "玩游戏积累10次",
        task3: "上麦累计360分钟",
        task4: "邀请新用户助力",
        noChip: "碎片不足",
        unlockSuc: "解锁成功",
        notask: "任务未完成",
        getSuc: "领取成功",
        ruleContent: `
        1.当你完成任务后，领取碎片，点击解锁拼图，就可以领取解锁的奖励<br/>
        2.领取奖励后，会自动放入背包<br/>
        3.任务规则<br/>
        (1)累计登录三天后可以领取两块碎片<br/>
        (2)任意玩以下游戏十次：ludo,飞镖,uno,domino,ok101 ，可以领取两块碎片<br/>
        (3)在任意房间内打开麦克风累计6个小时，可以领取2个碎片<br/>            
        (4)邀请新用户：累计邀请6个新用户，可以领取3个碎片<br/>
        （帮你助力的好友，必须是新用户，否则无法助力成功。）`,
        getDown: "已经领取",
        ptDown: "该拼图已经完成",
        share: "分享"
    },
    en: {
        rules: "Rules",
        get: "Get",
        chips: "Fragment",
        moreChips: "Invite friends to get more fragments",
        more: "More",
        unlock: "Unlock once",
        task: "Activity Task",
        task1: "Sign in for three days",
        task2: "Accumulate 10 games",
        task3: "microphone 360 minutes",
        task4: "Invite new users to assist",
        noChip: "Insufficient fragmentation",
        unlockSuc: "Unlock succeeded",
        notask: "Task not completed",
        getSuc: "Successfully received",
        ruleContent: `
        1. When you complete the task, collect the fragments, click to unlock the puzzle, and you can receive the reward for unlocking<br/>
        2. After receiving the reward, it will be automatically put into the backpack<br/>
        3. Mission Rules<br/>
        (1) You can receive two shards after logging in for three days<br/>
        (2) Play any of the following games ten times: ludo, darts, uno, domino, ok101, you can receive two fragments<br/>
        (3) Turn on the microphone in any room for a total of 6 hours, and you can receive 2 fragments<br/>
        (4) Invite new users: accumulatively invite 6 new users, you can receive 3 shards<br/>
        (Friends who help you to help you must be new users, otherwise you will not be able to help you successfully.
        `,
        getDown: "Received",
        ptDown: "The puzzle has been completed",
        share: "Share"
    },
    ar: {
        rules: "القواعد",
        get: "استلام",
        chips: "الأجزاء",
        moreChips: "قم بدعوة مستخدمين جدد للحصول على المزيد من الأجزاء",
        more: "أكثر",
        unlock: "فتح مرة واحدة",
        task: "مهام",
        task1: "تسجيل الدخول 3أيام",
        task2: `العب اللعبة 10 مرات من المجموع`,
        task3: "6 ساعات على الميكروفون",
        task4: `قم بدعوة مستخدمين جدد للمساعدة`,
        noChip: "الأجزاء غير كاف",
        unlockSuc: "فتح بنجاح",
        notask: "لم تكتمل المهمة ولا يمكن المطالبة بها",
        getSuc: "الحصول على النجاح",
        ruleContent: `
        1.بعد الانتهاء من المهمة، مطالبة الشظايا وانقر فوق اللغز فتح لتلقي المكافأة <br/>
        2.بعد تلقي المكافأة، سيتم وضعها تلقائيا في حقائب ظهرك <br/>
        3.قواعد المهام <br/>
        (1).بعد تسجيل الدخول لمدة ثلاثة أيام، يمكن أن تتلقى قطعتين من الحطام <br/>
        (2). يمكنك لعب الألعاب التالية عشر مرات في حسب اختيارك: Ludo, knife, uno, domino, ok101 ويمكن أن تتلقى قطعتين من الحطام <br/>
        (3).إذا قمت بتشغيل الميكروفون في اي غرفة لمدة 6 ساعات ، فيمكنك الحصول على قطعتين من الحطام <br/>
        (4) . دعوة مستخدمين جدد: دعوة 6 مستخدمين جدد في المجموع، ويمكنهم الحصول على 3 شظايا. <br/>
         (يجب أن يكون الأصدقاء الذين يدعمونك، مستخدمين جدد، وإلا فلن يتمكن من الداعم بنجاح.)
        `,
        getDown: "استلام",
        ptDown: "اكتمل اللغز",
        share: "المشاركة"
    },
    tr:{
    "rules": "Kurallar",
    "get": "Al",
    "chips": "Parça",
    "moreChips": "Daha fazla parça almak için arkadaşlarını davet et",
    "more": "Daha fazla",
    "unlock": "Bir kez aç",
    "task": "Etkinlik Görevi",
    "task1": "Üç gün boyunca giriş yap",
    "task2": "10 oyun biriktir",
    "task3": "Mikrofonu 360 dakika kullan",
    "task4": "Yeni kullanıcıları davet et ve yardımcı ol",
    "noChip": "Yetersiz parça",
    "unlockSuc": "Kilidi açma başarılı",
    "notask": "Görev tamamlanmadı",
    "getSuc": "Başarıyla alındı",
    "ruleContent": `
        1. Görevi tamamladığınızda, parçaları toplayın, yapbozun kilidini açmak için tıklayın ve kilit açma ödülünü alabilirsiniz<br/>
        2. Ödül alındıktan sonra otomatik olarak sırt çantasına eklenir<br/>
        3. Görev Kuralları<br/>
        (1) Üç gün boyunca giriş yaptıktan sonra iki parça alabilirsiniz<br/>
        (2) Aşağıdaki oyunlardan herhangi birini on kez oynayın: ludo, dart, uno, domino, ok101, iki parça alabilirsiniz<br/>
        (3) Herhangi bir odada toplam 6 saat mikrofonu açın ve 2 parça alabilirsiniz<br/>
        (4) Yeni kullanıcıları davet edin: Toplamda 6 yeni kullanıcı davet ederseniz, 3 parça alabilirsiniz<br/>
        (Size yardımcı olan arkadaşların yeni kullanıcı olması gerekir, aksi takdirde başarıyla yardımcı olamazlar.)
    `,
    "getDown": "Alındı",
    "ptDown": "Yapboz tamamlandı",
    "share": "Paylaş"
},
    pt:{
    "rules": "Regras",
    "get": "Obter",
    "chips": "Fragmento",
    "moreChips": "Convide amigos para obter mais fragmentos",
    "more": "Mais",
    "unlock": "Desbloquear uma vez",
    "task": "Tarefa da Atividade",
    "task1": "Faça login por três dias",
    "task2": "Acumule 10 jogos",
    "task3": "Microfone por 360 minutos",
    "task4": "Convide novos usuários para ajudar",
    "noChip": "Fragmentos insuficientes",
    "unlockSuc": "Desbloqueio bem-sucedido",
    "notask": "Tarefa não concluída",
    "getSuc": "Recebido com sucesso",
    "ruleContent":
        "1. Quando você concluir a tarefa, colete os fragmentos, clique para desbloquear o quebra-cabeça e receba a recompensa de desbloqueio.<br/>" +
        "2. Após receber a recompensa, ela será adicionada automaticamente à mochila.<br/>" +
        "3. Regras da missão:<br/>" +
        "(1) Você pode receber dois fragmentos após fazer login por três dias.<br/>" +
        "(2) Jogue qualquer um dos seguintes jogos dez vezes: ludo, dardos, uno, dominó, ok101 e receba dois fragmentos.<br/>" +
        "(3) Ative o microfone em qualquer sala por um total de 6 horas para receber 2 fragmentos.<br/>" +
        "(4) Convide novos usuários: convide 6 novos usuários no total e receba 3 fragmentos.<br/>" +
        "(Os amigos que ajudam você devem ser novos usuários, caso contrário, a ajuda não será bem-sucedida.)",
    "getDown": "Recebido",
    "ptDown": "O quebra-cabeça foi concluído",
    "share": "Compartilhar"
},
    id:{
    "rules": "Aturan",
    "get": "Dapatkan",
    "chips": "Fragmen",
    "moreChips": "Undang teman untuk mendapatkan lebih banyak fragmen",
    "more": "Lebih",
    "unlock": "Buka sekali",
    "task": "Tugas Aktivitas",
    "task1": "Masuk selama tiga hari",
    "task2": "Akumulasi 10 permainan",
    "task3": "Mikrofon 360 menit",
    "task4": "Undang pengguna baru untuk membantu",
    "noChip": "Fragmen tidak mencukupi",
    "unlockSuc": "Berhasil dibuka",
    "notask": "Tugas belum selesai",
    "getSuc": "Berhasil diterima",
    "ruleContent":
        "1. Saat Anda menyelesaikan tugas, kumpulkan fragmen, klik untuk membuka teka-teki, dan Anda bisa menerima hadiah pembukaan.<br/>" +
        "2. Setelah menerima hadiah, hadiah akan secara otomatis dimasukkan ke dalam tas ransel.<br/>" +
        "3. Peraturan Misi:<br/>" +
        "(1) Anda dapat menerima dua fragmen setelah masuk selama tiga hari.<br/>" +
        "(2) Mainkan salah satu permainan berikut sepuluh kali: ludo, darts, uno, domino, ok101, Anda bisa menerima dua fragmen.<br/>" +
        "(3) Nyalakan mikrofon di ruangan mana saja selama total 6 jam, dan Anda bisa menerima 2 fragmen.<br/>" +
        "(4) Undang pengguna baru: undang total 6 pengguna baru, Anda bisa menerima 3 fragmen.<br/>" +
        "(Teman yang membantu Anda harus pengguna baru, jika tidak, bantuan tidak akan berhasil.)",
    "getDown": "Diterima",
    "ptDown": "Teka-teki telah selesai",
    "share": "Bagikan"
},
    uz:{
    "rules": "Qoidalar",
    "get": "Olish",
    "chips": "Bo‘lak",
    "moreChips": "Ko‘proq bo‘lak olish uchun do‘stlarni taklif qiling",
    "more": "Ko‘proq",
    "unlock": "Bitta ochish",
    "task": "Faoliyat vazifasi",
    "task1": "Uch kun tizimga kirish",
    "task2": "10 ta o‘yinni yig‘ish",
    "task3": "Mikrofon 360 daqiqa",
    "task4": "Yangi foydalanuvchilarni yordamga taklif qilish",
    "noChip": "Yetarli bo‘lak yo‘q",
    "unlockSuc": "Muvaffaqiyatli ochildi",
    "notask": "Vazifa bajarilmadi",
    "getSuc": "Muvaffaqiyatli qabul qilindi",
    "ruleContent":
        "1. Vazifani bajarganingizda, bo‘laklarni to‘plang, jumboqni ochish uchun bosing va ochish mukofotini olishingiz mumkin.<br/>" +
        "2. Mukofot olingandan keyin avtomatik tarzda ryukzakka joylanadi.<br/>" +
        "3. Missiya qoidalari:<br/>" +
        "(1) Uch kun tizimga kirgandan keyin ikki bo‘lak olishingiz mumkin.<br/>" +
        "(2) Quyidagi o‘yinlardan birini o‘n marta o‘ynang: ludo, darts, uno, domino, ok101, siz ikki bo‘lak olasiz.<br/>" +
        "(3) Istalgan xonada mikrofonni jami 6 soat yoqing, va 2 bo‘lak olishingiz mumkin.<br/>" +
        "(4) Yangi foydalanuvchilarni taklif qilish: jami 6 yangi foydalanuvchini taklif qiling, 3 bo‘lak olishingiz mumkin.<br/>" +
        "(Sizga yordam berayotgan do‘stlaringiz yangi foydalanuvchilar bo‘lishi kerak, aks holda ular muvaffaqiyatli yordam bera olmaydi.)",
    "getDown": "Qabul qilindi",
    "ptDown": "Jumboq tugallandi",
    "share": "Ulashish"
},
    ru:{
    "rules": "Правила",
    "get": "Получить",
    "chips": "Фрагмент",
    "moreChips": "Пригласите друзей, чтобы получить больше фрагментов",
    "more": "Еще",
    "unlock": "Разблокировать один раз",
    "task": "Задача активности",
    "task1": "Войти в систему в течение трех дней",
    "task2": "Накопить 10 игр",
    "task3": "Микрофон 360 минут",
    "task4": "Пригласить новых пользователей для помощи",
    "noChip": "Недостаточно фрагментов",
    "unlockSuc": "Разблокировано успешно",
    "notask": "Задача не выполнена",
    "getSuc": "Успешно получено",
    "ruleContent":
        "1. Когда вы выполните задание, соберите фрагменты, нажмите, чтобы разблокировать головоломку, и получите награду за разблокировку.<br/>" +
        "2. После получения награды она автоматически помещается в рюкзак.<br/>" +
        "3. Правила выполнения заданий:<br/>" +
        "(1) Вы можете получить два фрагмента после входа в систему в течение трех дней.<br/>" +
        "(2) Сыграйте в любую из следующих игр десять раз: лудо, дартс, уно, домино, ok101, и получите два фрагмента.<br/>" +
        "(3) Включите микрофон в любой комнате в общей сложности на 6 часов и получите 2 фрагмента.<br/>" +
        "(4) Пригласите новых пользователей: пригласите 6 новых пользователей и получите 3 фрагмента.<br/>" +
        "(Друзья, которые вам помогают, должны быть новыми пользователями, иначе помощь не засчитается.)",
    "getDown": "Получено",
    "ptDown": "Головоломка завершена",
    "share": "Поделиться"
},
    fa:{
    "rules": "قوانین",
    "get": "دریافت",
    "chips": "قطعه",
    "moreChips": "دوستتان را دعوت کنید تا قطعات بیشتری دریافت کنید",
    "more": "بیشتر",
    "unlock": "یک بار باز کنید",
    "task": "وظیفه فعالیت",
    "task1": "سه روز وارد شوید",
    "task2": "10 بازی جمع آوری کنید",
    "task3": "میکروفن 360 دقیقه",
    "task4": "کاربران جدید را برای کمک دعوت کنید",
    "noChip": "قطعات کافی نیست",
    "unlockSuc": "باز کردن با موفقیت انجام شد",
    "notask": "وظیفه تکمیل نشده",
    "getSuc": "با موفقیت دریافت شد",
    "ruleContent":
        "1. وقتی وظیفه را تکمیل کردید، قطعات را جمع آوری کنید، روی باز کردن پازل کلیک کنید و می‌توانید پاداش باز کردن را دریافت کنید.<br/>" +
        "2. پس از دریافت پاداش، به طور خودکار به کوله‌پشتی شما اضافه می‌شود.<br/>" +
        "3. قوانین وظیفه:<br/>" +
        "(1) شما می‌توانید پس از ورود به سیستم به مدت سه روز دو قطعه دریافت کنید.<br/>" +
        "(2) هر یک از بازی‌های زیر را ده بار بازی کنید: لودو، دارت، اونو، دومینو، ok101، و دو قطعه دریافت خواهید کرد.<br/>" +
        "(3) میکروفن را در هر اتاق برای مجموعاً 6 ساعت روشن کنید و دو قطعه دریافت خواهید کرد.<br/>" +
        "(4) کاربران جدید را دعوت کنید: به طور تجمعی 6 کاربر جدید دعوت کنید و 3 قطعه دریافت خواهید کرد.<br/>" +
        "(دوستانی که به شما کمک می‌کنند باید کاربران جدید باشند وگرنه نمی‌توانید به درستی کمک بگیرید.)",
    "getDown": "دریافت شد",
    "ptDown": "پازل تکمیل شده است",
    "share": "اشتراک گذاری"
}






}




// WEBPACK FOOTER //
// src/pages/activity/ramadanJigsaw/lang.js